/// <amd-module name="Test/TestPlansHubRefresh/AuthorPivotMenuService/AuthorPivotMenuService" />
import { IAuthorPivotHeaderMenuParams } from "Test/TestPlansHubRefresh/AuthorPivotMenuService/AuthorPivotMenuService.types";
import { AuthorActions } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorActions";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
export interface IAuthorPivotMenuService {
    addTestCaseUsingWitForm(params: IAuthorPivotHeaderMenuParams): void;
    addExistingTestCasesToSuite(params: IAuthorPivotHeaderMenuParams): void;
    addTestCasesUsingGrid(params: IAuthorPivotHeaderMenuParams): void;
}

export class AuthorPivotMenuService extends VssService implements IAuthorPivotMenuService {
    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
    }

    public _serviceRestart(pageContext: IVssPageContext): void {
        super._serviceRestart(pageContext);
    }

    public addTestCaseUsingWitForm(params: IAuthorPivotHeaderMenuParams): void {
        params.dispatch(AuthorActions.openNewTestCaseWitForm(params.planId, params.suiteId, params.areaPath, params.iterationPath));
    }

    public addExistingTestCasesToSuite(params: IAuthorPivotHeaderMenuParams): void {
        params.dispatch(AuthorActions.addExistingTestCases(params.planId, params.suiteId, params.areaPath));
    }

    public addTestCasesUsingGrid(params: IAuthorPivotHeaderMenuParams): void {
        params.dispatch(
            AuthorActions.addOrEditTestCasesUsingGrid([], params.planId, params.suiteId, params.planName, params.areaPath, params.iterationPath)
        );
    }
}

Services.add("IAuthorPivotMenuService", { serviceFactory: AuthorPivotMenuService });
